<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-tabs v-model="tab" show-arrows>
          <v-tab>Ստուգումներ</v-tab>
          <v-tab v-if="DBAccess">Տվյալների բազա</v-tab>
          <v-tab v-if="DBAccess">Գործողությունների ցուցակ</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-show="tab == 0">
            <Checkings />
          </v-tab-item>
          <v-tab-item v-show="tab == 1 && DBAccess">
            <v-card flat>
              <v-card-text><DataBase /></v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-show="tab == 2 && DBAccess">
            <v-card flat>
              <v-card-text><Logs /></v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Checkings from "@/components/Checkings";
import Logs from "@/components/Logs";
import DataBase from "@/components/DataBase";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  components: {
    Checkings,
    Logs,
    DataBase,
  },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    ...mapGetters(["getUser", "getDBAccess"]),
    DBAccess() {
      console.log(localStorage.getItem("dbAccess"));
      return JSON.parse(localStorage.getItem("dbAccess"));
    },
  },
};
</script>
